export default "__VITE_ASSET__28d9d944__"